import React from 'react';
import { PricingTableItem } from './elements/PricingTableItem';

interface IPricingAttributeTable {}

export const PricingAttributeTable: React.FC<IPricingAttributeTable> = () => {
    return (
        <section className="relative mx-auto flex w-full max-w-7xl flex-col gap-1 rounded-xl bg-neutral-800 p-4 md:p-8">
            <div className="relative mb-8 grid grid-cols-[30%,2fr,2fr,2fr] text-neutral-500 md:grid-cols-[50%,2fr,2fr,2fr]">
                <span />
                <span className="text-center font-bold text-xs md:text-xl">Single Tenant</span>
                <span className="text-center font-bold text-xs md:text-xl">Multi Tenant</span>
                <span className="text-center font-bold text-xs md:text-xl">Fully Custom</span>
            </div>

            <PricingTableItem itemKey="priceMonthly" label="Price Monthly" />
            <PricingTableItem itemKey="priceYearly" label="Price Yearly" />
            <PricingTableItem itemKey="priceMonthlyDiscounted" label="Price Monthly Discounted" />
            <PricingTableItem
                itemKey="priceYearlyDiscountPercentage"
                label="Price Yearly Discount Percentage"
            />
            <PricingTableItem itemKey="priceAdditionalTenant" label="Additional Tenant" />
            <PricingTableItem itemKey="customizationPercentage" label="Customization Percentage" />
            <PricingTableItem itemKey="priceCustomizationRate" label="Customization Rate" />
            <PricingTableItem itemKey="tenantsIncluded" label="Tenants Included" />
            <PricingTableItem itemKey="demoTenantsIncluded" label="Demo Tenants Included" />
            <PricingTableItem itemKey="languages" label="Languages" />
            <PricingTableItem itemKey="bringYourOwnDomain" label="Bring Your Own Domain" />
            <PricingTableItem itemKey="sapAriba" label="SAP Ariba" />
            <PricingTableItem itemKey="cloudbarSubdomain" label="Cloudbar Subdomain" />
            <PricingTableItem itemKey="pwaOfflineCapabilities" label="PWA Offline Capabilities" />
            <PricingTableItem
                itemKey="contextualAITranslations"
                label="Contextual AI Translations"
            />
            <PricingTableItem itemKey="pageCMS" label="Page CMS" />
            <PricingTableItem itemKey="eCommerce" label="eCommerce" />
            <PricingTableItem itemKey="approvalSystem" label="Approval System" />
            <PricingTableItem itemKey="themeBranding" label="Theme & Branding" />
            <PricingTableItem itemKey="sendGridIntegration" label="SendGrid Integration" />
            <PricingTableItem itemKey="chat" label="Chat" />
            <PricingTableItem itemKey="pushNotifications" label="Push Notifications" />
            <PricingTableItem itemKey="twoFAMail" label="Two-Factor Authentication (Mail)" />
            <PricingTableItem
                itemKey="twoFAAuthenticator"
                label="Two-Factor Authentication (Authenticator)"
            />
            <PricingTableItem itemKey="aiTextGeneration" label="AI Text Generation" />
            <PricingTableItem itemKey="aiWebToPrintAssistant" label="AI Web To Print Assistant" />
            <PricingTableItem itemKey="customSendGridTemplates" label="Custom SendGrid Templates" />
            <PricingTableItem itemKey="sso" label="Single Sign-On" />
            <PricingTableItem itemKey="apiRestAPI" label="Rest API" />
            <PricingTableItem itemKey="setupTime" label="Setup Time" />
        </section>
    );
};
